import { render } from "./clients-details-modal.vue?vue&type=template&id=65b64217"
import script from "./clients-details-modal.vue?vue&type=script&lang=js"
export * from "./clients-details-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__